import {Injectable, signal} from '@angular/core';
import {DailyFeedbackReportsContentData, DailyFeedbackReportsData} from "../types/daily-feedback-reports-page.types";

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsDataService {
  private _dailyFeedbackReportsData = signal<Array<DailyFeedbackReportsContentData>>([]);
  public dailyFeedbackReportsData = this._dailyFeedbackReportsData.asReadonly();

  public setDailyFeedbackReportsData(data: DailyFeedbackReportsData | null): void {
    this._dailyFeedbackReportsData.set(data ? data.content : []);
  }
}
